export default {
	"exchange.PleaseSelectTheProductInformationYouWantToRedeem": "請選擇需要兌換的商品資訊",
	"exchange.NoRedemptionCode": "無兌換碼",
	"exchange.PleaseEnterYourAddressInformation": "請輸入地址資訊",
	"exchange.prompt": "提示",
	"exchange.AccordingToTheRequirementsOfNationalPoliciesTheExpressMailSentToTaiwanNeedsToFillInTheCertificateNumberPleaseFillIn": "根據國家政策要求，發往臺灣地區的快件需填寫證件號碼，請您補充填寫",
	"exchange.Cancel": "取消",
	"exchange.GoFillItOut": "去填寫",
	"exchange.SorryYouDoNotMeetTheNewUserPurchaseRulesPleaseGoToTheLoveToReadPublicAccountToBuyAfterRefund": "抱歉，您不滿足新使用者購買規則，請退款後前往“愛閱讀的叫叫”公眾號購買",
	"exchange.TheProductWasRedeemedSuccessfully": "商品兌換成功！",
	"exchange.ActivationCodeRedemptionSuccessful": "激活碼兌換成功！",
	"exchange.NoActivationAddress": "無啟動位址！",
	"exchange.RedemptionActivationFailed": "兌換激活失敗！",
	"exchange.RedeemGoods": "兌換商品",
	"exchange.ShippingAddress": "收貨位址",
	"exchange.PhysicalTeachingMaterialsWillBeSentToThisAddress": "實物教材將寄送至該位址",
	"exchange.ParameterError": "參數錯誤！",
	"exchange.PleaseFillInTheInformation": "請填寫資訊",
	"exchange.NewRevenueInformation": "新增收貨資訊",
	"exchange.SelectAProduct": "選擇商品",
	"exchange.DetailedChecklist": "詳細清單",
	"exchange.ThisRedemptionIncludesTheFollowing": "本次兌換商品包含以下內容",
	"exchange.Gifts": "贈品",
	"exchange.Real": "實物",
	"exchange.Tips": "溫馨提示",
	"exchange.1TheSkuOfTheSelectedProductCannotBeReplacedOnceItIsRedeemedPleaseChooseCarefully": "1、選擇商品的sku一經兌換不得進行更換，請認真選擇。",
	"exchange.2IfTheSkuContainsAGiftTheGiftCanBeReplacedWithin24HoursAfterTheGiftRedemptionIsSuccessfullyActivatedAndTheInstructorCanBeContactedForReplacementAndItWillNotBeReplacedAfterTheTimeout": "2、sku中若包含贈品，贈品兌換啟動成功24小時之內可聯繫指導師進行更換，超時后不予更換。",
	"exchange.3TheGiveawayCannotBeReplacedAfterTheExperienceRecordIsGenerated": "3、贈品產生體驗記錄后不可更換。",
	"exchange.Customer": "客服",
	"exchange.ConfirmTheInformation": "確認資訊"
}